<template>
  <div
    class="tab pt-sm-5"
    :class="{ 'full-height justify-start ma-auto width-120': rewardsTemplate }"
  >
    <div
      class="dot d-block"
      :class="{ 'scale-8': rewardsTemplate && $vuetify.breakpoint.xs }"
    >
      <svg>
        <image
          style="width: 85px"
          :href="club.image"
          x="0"
          y="10"
          clip-path="inset(0% round 50px)"
        ></image>
        <circle
          :style="lines()"
          r="40"
          cx="43"
          cy="42.5"
          fill="none"
          stroke-width="6"
          stroke="#cdcbcb"
        ></circle>
        <circle
          v-if="club.stars_in_this_cycle"
          :style="lines2()"
          r="40"
          cx="43"
          cy="42.5"
          fill="none"
          stroke-width="6"
          :stroke="[rewardsTemplate ? 'var(--v-primary-base)' : '#e3222f']"
        ></circle>
        <circle
          cx="75"
          cy="15"
          r="11"
          fill="#e3222f"
          v-if="club.free_products_qty"
        />
        <text
          x="25%"
          y="12.5%"
          text-anchor="middle"
          fill="white"
          font-size="12px"
          v-if="club.free_products_qty"
        >
          {{ club_free_products_qty_remaining(club.club_id) }}
        </text>
      </svg>
    </div>
    <p
      :title="club.name"
      class="offer-name pt-3 text-center"
      :class="{ 'primary--text text-subtitle-2 ': rewardsTemplate }"
    >
      {{ club.name }}
      <span
        v-if="rewardsTemplate"
        class="font-weight-regular secondary--text text-11"
        ><br />
        {{ club.stars_in_this_cycle }} out of {{ club.min_products }}
      </span>
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ClubTab",
  components: {},
  computed: {
    ...mapGetters("store", {
      club_free_products_qty_remaining: "club_free_products_qty_remaining",
    }),
  },
  methods: {
    lines() {
      const gap = 5;
      const circleRadius = 40;
      const need_to_buy = this.club.min_products;
      const dashLength = 2 * circleRadius * 3.1415 * (1 / need_to_buy) - gap;
      return {
        strokeDasharray: `${dashLength}px ${gap}px`,
        strokeDashoffset: `-${gap / 2}px`,
        "transform-box": "fill-box",
        "transform-origin": "center",
        "-webkit-transform": "rotate(-90deg)",
        transform: "rotate(-90deg)",
      };
    },
    lines2() {
      const gap = 5;
      const circleRadius = 40;
      const need_to_buy = this.club.min_products;
      const dashLength = 2 * circleRadius * 3.1415 * (1 / need_to_buy) - gap;
      const bought = this.club.stars_in_this_cycle;
      let dasharrayStr = "";
      for (var i = 0; i < bought; i++) {
        dasharrayStr += `${dashLength}px ${gap}px, `;
        if (i === bought - 1) {
          for (var j = 0; j < need_to_buy - bought; j++) {
            dasharrayStr += `0px ${dashLength + gap}px`;
            if (j != need_to_buy - bought - 1) dasharrayStr += ", ";
          }
        }
      }
      return {
        strokeDasharray: dasharrayStr,
        strokeDashoffset: `-${gap / 2}px`,
        "transform-box": "fill-box",
        "transform-origin": "center",
        "-webkit-transform": "rotate(-90deg)",
        transform: "rotate(-90deg)",
      };
    },
  },
  props: {
    club: Object,
    rewardsTemplate: Boolean,
  },
};
</script>

<style scoped>
image {
  mix-blend-mode: multiply;
  height: 60px;
  border-radius: 50%;
}
.dot {
  height: 85px;
  width: 85px;
  background-color: white;
  border-radius: 50%;
  display: inline-block;
  display: flex;
  justify-content: center;
}
.scale-8 {
  transform: scale(0.8);
}
.offer-name {
  max-width: 90%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.text-11 {
  font-size: 11px;
}
.width-120 {
  max-width: 120px;
}
</style>
